/*
 * Copyright (c) 2021.  Sanish Manandhar
 * All Rights Reserved
 */

export const EXPORT_CHAT_REQUEST = 'EXPORT_CHAT_REQUEST';
export const EXPORT_CHAT_REQUEST_SUCCESS = 'EXPORT_CHAT_REQUEST_SUCCESS';
export const EXPORT_CHAT_REQUEST_FAILURE = 'EXPORT_CHAT_REQUEST_FAILURE';

export const SEND_CHAT_NOTIFICATION_REQUEST = 'SEND_CHAT_NOTIFICATION_REQUEST';
export const SEND_CHAT_NOTIFICATION_REQUEST_SUCCESS = 'SEND_CHAT_NOTIFICATION_REQUEST_SUCCESS';
export const SEND_CHAT_NOTIFICATION_REQUEST_FAILURE = 'SEND_CHAT_NOTIFICATION_REQUEST_FAILURE';

export const SEND_AUTOMATIC_MESSAGE_REQUEST = 'SEND_AUTOMATIC_MESSAGE_REQUEST';
export const SEND_AUTOMATIC_MESSAGE_REQUEST_SUCCESS = 'SEND_AUTOMATIC_MESSAGE_REQUEST_SUCCESS';
export const SEND_AUTOMATIC_MESSAGE_REQUEST_FAILURE = 'SEND_AUTOMATIC_MESSAGE_REQUEST_FAILURE';
